import IconDisplay from '../icon-display/IconDisplay';
import { computeAria, checkIsSelected } from '../icon-input/icons-menu/utils';
import c from './shortcut-icon-button.module.scss';

const ShortcutIconButton = ({ iconData, selectedIcon, onClick, inputUrl }) => {
  const aria = computeAria(iconData);

  return (
    <button
      type="button"
      className={`${c.iconButton} ${
        checkIsSelected(selectedIcon, iconData) ? c.selected : ''
      }`}
      key={iconData.character || iconData.app}
      onClick={() => onClick(iconData)}
      aria-label={aria}
    >
      <IconDisplay icon={iconData} url={inputUrl} />
    </button>
  );
};

export default ShortcutIconButton;
